import { render, staticRenderFns } from "./KlimaView.vue?vue&type=template&id=8ebd7010&"
import script from "./KlimaView.vue?vue&type=script&lang=js&"
export * from "./KlimaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports